var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBotMessageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40.57 37.537"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 16547",
  fill: "#f9a13a"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14864"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2186",
  d: "M22.319 22.993a11.351 11.351 0 01-2.333-18.589 11.223 11.223 0 00-3.618 4.2 11.343 11.343 0 004.954 15.173 11.113 11.113 0 0012.416-1.588 11.1 11.1 0 01-11.419.804z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2187",
  d: "M23.631 20.483a8.666 8.666 0 01-1.909-14.078 8.573 8.573 0 00-2.871 3.279 8.66 8.66 0 003.783 11.582 8.485 8.485 0 009.6-1.323 8.474 8.474 0 01-8.603.54z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2188",
  d: "M25.073 17.846a5.978 5.978 0 01-1.454-9.584 5.909 5.909 0 00-2.152 2.376 5.979 5.979 0 002.611 8 5.86 5.86 0 006.768-1.045 5.85 5.85 0 01-5.773.253z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14865"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2189",
  d: "M9.4 34.913a14.918 14.918 0 01-3.066-24.435 14.724 14.724 0 00-4.754 5.52 14.911 14.911 0 006.515 19.946 14.606 14.606 0 0016.318-2.087A14.6 14.6 0 019.4 34.913z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2190",
  d: "M10.966 31.776a11.4 11.4 0 01-2.5-18.507 11.25 11.25 0 00-3.775 4.312 11.387 11.387 0 004.975 15.228 11.168 11.168 0 0012.626-1.739 11.164 11.164 0 01-11.326.706z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2191",
  d: "M12.535 28.641a7.861 7.861 0 01-3.433-10.513 7.772 7.772 0 011.521-2.09 7.767 7.767 0 00-2.83 3.125 7.855 7.855 0 003.435 10.509 7.706 7.706 0 008.9-1.372 7.7 7.7 0 01-7.593.341z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14874"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2215",
  d: "M21.907 8.047a14.92 14.92 0 014.2 24.262 14.738 14.738 0 004.492-5.741A14.9 14.9 0 0023.16 6.954a14.614 14.614 0 00-16.2 2.858 14.608 14.608 0 0114.947-1.765z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2216",
  d: "M20.488 11.256a11.391 11.391 0 013.366 18.365 11.246 11.246 0 003.571-4.484 11.38 11.38 0 00-5.68-14.976 11.172 11.172 0 00-12.531 2.337 11.157 11.157 0 0111.274-1.242z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2217",
  d: "M19.067 14.463a7.866 7.866 0 012.5 12.5 7.8 7.8 0 10-10.062-11.8 7.7 7.7 0 017.562-.7z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14875"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2218",
  d: "M33.314 1.951a11.349 11.349 0 012.54 18.56 11.211 11.211 0 003.571-4.239 11.343 11.343 0 00-5.123-15.115 11.115 11.115 0 00-12.4 1.727 11.109 11.109 0 0111.412-.933z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2219",
  d: "M32.026 4.476a8.665 8.665 0 012.066 14.054A8.595 8.595 0 1023.425 5.115a8.473 8.473 0 018.601-.639z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2220",
  d: "M30.616 7.128a5.979 5.979 0 011.562 9.569 5.883 5.883 0 002.126-2.4 5.977 5.977 0 00-2.7-7.965 5.862 5.862 0 00-6.756 1.122 5.852 5.852 0 015.768-.326z"
})))));
export default __webpack_public_path__ + "static/BotMessageIcon.4b87e4ef8bebd36b87906548541d78c3.svg";
export { SvgBotMessageIcon as ReactComponent };